import { useState } from "react";

import { Avatar, Divider, Modal } from "antd";
import { NavLink } from "react-router-dom";

import useLoggedUser from "../../../api/hooks/customHooks/useGetLoggedUser";
import LogoutIcon from "../../../assets/icons/sidebar/LogoutIcon";
import ProfileIcon from "../../../assets/icons/sidebar/ProfileIcon";
import useLogout from "../../../hooks/useLogout";
import Profile from "../../Profile/Profile";

import "./UserDetails.scss";

const propTypes = {};

const defaultProps = {};

function UserDetails() {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const logout = useLogout();
  const { user } = useLoggedUser();

  const onAvatarClick = () => {
    setIsProfileModalOpen(true);
  };

  return (
    <div className="flex items-center justify-center">
      <Divider
        type="vertical"
        style={{ height: "2em", borderColor: "#ffffff" }}
      />
      <Avatar
        shape="square"
        onClick={onAvatarClick}
        title="Profile"
        icon={!user?.ImageUrl ? <ProfileIcon /> : null}
        src={user?.ImageUrl ? user?.ImageUrl : null}
        className="flex items-center justify-center cursor-pointer bg-[#252331] text-triple-background mr-2"
      />
      <div className="flex flex-col">
        <span data-testid="user-firstName">{user?.FirstName}</span>
        <span className="text-12" data-testid="user-role">
          {user?.Roles[0]}
        </span>
      </div>
      <Modal
        className="profile-modal"
        maskClosable={false}
        footer={null}
        open={isProfileModalOpen}
        keyboard={false}
        onCancel={() => setIsProfileModalOpen(false)}
        width={550}
      >
        <Profile />
      </Modal>
      <Divider
        type="vertical"
        style={{ height: "2em", borderColor: "#ffffff" }}
      />
      <NavLink
        to="/login"
        className="flex items-center"
        onClick={logout}
        title="Logout"
        data-testid="logout-btn"
      >
        <LogoutIcon />
      </NavLink>
    </div>
  );
}

UserDetails.propTypes = propTypes;
UserDetails.defaultProps = defaultProps;

export default UserDetails;
